<div class="advertisement"
    *ngFor="let ad of adIframeHtmlArray; index as i" #adElement>
    <div [innerHtml]="adIframeHtmlArray[i]" [ngClass]="{ 'hidden': i != currentAdIndex }">

    </div>
</div>